import { ProductAttributeSelectorProps } from '../config.types';
import React from 'react';
import { useGetAttributeDataForSelector } from './hooks/getAttributeDataForSelector';
import { useGetFoilConfigs } from '../utils/mappings/useDeriveFoilIds';
import { ChoiceGroup, useCustomizationContext } from '@apps/card/routes/CardCustomizer';
import { Flex, Box } from '@withjoy/joykit';
import { useMinorUnitsToPriceString } from '@apps/card/hooks/useMinorUnitsToPriceString';
import { useTranslation } from '@shared/core';

export const FoilChoiceAttribute = (props: ProductAttributeSelectorProps) => {
  const { product, attributeId, priceCalculator } = props;
  const data = useGetAttributeDataForSelector(props);
  const { getFoilConfigs } = useGetFoilConfigs();
  const [cardQuantity] = useCustomizationContext(draft => draft.config.customizations.quantity);
  const formatPrice = useMinorUnitsToPriceString();
  const { tq } = useTranslation('stationery');

  if (!data || !data.options.selected) {
    return null;
  }

  //   const uiConfig = data.attribute.attributeUIConfig;
  //   const options = data.options.uiConfigurations;
  const state = data.state;
  const selectedOptionId = data.options.selected.optionId;
  const selectedOptionPrice = priceCalculator.getOptionPrice(product.id, { attributeId, optionId: selectedOptionId }, cardQuantity);
  const formattedOptionPrice = formatPrice(selectedOptionPrice, { canShowFreeLabel: true });

  const foilConfigs = getFoilConfigs(product, attributeId);

  if (!foilConfigs) {
    return null;
  }
  const selectedFoil = foilConfigs.find(f => f.optionId === selectedOptionId);

  const getName = (optionId: string) => {
    const option = data.options.uiConfigurations.find(o => o.optionId === optionId);
    return option?.translations.selector.displayName ?? '';
  };

  return (
    <ChoiceGroup
      value={selectedFoil!.optionId}
      getName={getName}
      title={tq`Foil`}
      price={selectedOptionPrice !== 0 ? `+ ${formattedOptionPrice}` : formattedOptionPrice}
    >
      <Flex gap={3}>
        {foilConfigs.map(foilOffer => {
          const isSelected = foilOffer.optionId === selectedOptionId;

          return (
            <Flex
              borderRadius={44}
              justifyContent="center"
              alignItems="center"
              position="relative"
              width={44}
              height={44}
              key={foilOffer.colorId}
              as="button"
              backgroundColor={isSelected ? 'mono14' : 'mono2'}
              //   onClick={() => onSelect(foilOffer.colorId)}
              onClick={() => {
                state.setOptionId(foilOffer.optionId);
              }}
            >
              <Box
                position="absolute"
                width={38}
                height={38}
                borderRadius={38}
                backgroundImage={`url(${foilOffer.assetThumbnailUrl})`}
                backgroundSize="cover"
                backgroundPosition="center"
                outline={isSelected ? '1px solid white' : '2px solid white'}
              />
            </Flex>
          );
        })}
      </Flex>
      {/* {!hideLearnMore && (
        <Box marginTop={3} position="relative" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
          <TextV2 typographyVariant="label2" textDecoration="underline" textDecorationColor="#D9D9D9" cursor="default">
            {tFoilTooltip.cta()}
          </TextV2>
          <Flex
            position="absolute"
            flexDirection="column"
            bottom="-0.5rem"
            right="0"
            left="0"
            background="white"
            transform="translateY(100%)"
            boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.07), 0px 7px 27px 0px rgba(44, 41, 37, 0.06)"
            borderRadius={4}
            padding={5}
            paddingBottom={6}
            gap={5}
            zIndex={10}
            opacity={isVisible ? 1 : 0}
            visibility={isVisible ? 'visible' : 'hidden'}
            transition={animationTransition('opacity', 'visibility')}
            transitionDelay="0.3s"
            maxWidth="310px"
          >
            <Box as="img" src="https://withjoy.com/assets/public/stationery-print-foil-preview.png" width="100%" backgroundColor="mono3" borderRadius={3} />
            <Flex flexDirection="column" gap={3}>
              <TextV2 typographyVariant="button1">{tFoilTooltip.title()}</TextV2>
              <TextV2 typographyVariant="label2">{tFoilTooltip.description()}</TextV2>
            </Flex>
          </Flex>
        </Box>
      )} */}
    </ChoiceGroup>
  );
};
